import { Box, Chip, Typography } from "@mui/material";
import RestaurantIcon from "@mui/icons-material/Restaurant";

export const buildColumnsMenus = () => [
  {
    accessorKey: "nombre",
    header: "Menú",
    Cell: ({ cell }) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <RestaurantIcon sx={{ fontSize: 18, color: "#1F618D" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "0.88rem" }}>
          {cell.getValue()}
        </Typography>
      </Box>
    ),
  },
  {
    accessorKey: "proveedor",
    header: "Proveedor",
  },
  {
    accessorKey: "activo",
    header: "Estado",
    maxSize: 90,
    muiTableBodyCellProps: { align: "center" },
    muiTableHeadCellProps: { align: "center" },
    Cell: ({ cell }) => {
      const activo = Number(cell.getValue()) === 1;
      return (
        <Chip
          label={activo ? "Activo" : "Inactivo"}
          size="small"
          sx={{
            fontWeight: 700,
            height: 22,
            bgcolor: activo ? "rgba(46,125,50,0.12)" : "rgba(211,47,47,0.1)",
            color: activo ? "#1B5E20" : "#B71C1C",
          }}
        />
      );
    },
  },
];
